<template>
  <div>
    <el-tabs v-model="sixactiveName" type="card" @tab-click="handleClick">
      <el-tab-pane label="学生信息" name="first">
        <el-form :inline="true" :model="form">
          <el-col :span="8">
            <el-form-item label="学生姓名:" label-width="100px">
              <div class="div">{{ form.realName }}</div>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
          <el-form-item label="身份证号码:" label-width="100px">
            <div class="div">{{form.identityNumber}}</div>
          </el-form-item>
        </el-col> -->
          <el-col :span="8">
            <el-form-item label="服务电话:" label-width="100px">
              <div class="div">{{ form.servicePhone }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性 别:" label-width="100px">
              <div class="div" v-if="form.sex === 0">男</div>
              <div class="div" v-if="form.sex === 1">女</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="民 族:" label-width="100px">
              <div class="div">{{ form.nation }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="毕业年份:" label-width="100px">
              <div class="div">{{ form.graduateYear }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="就读学校:" label-width="100px">
              <div class="div">{{ form.school }}</div>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="户籍省份:" label-width="100px">
              <div class="div">{{ form.residenceProvince }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="户籍市:" label-width="100px">
              <div class="div">{{ form.residenceCity }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="户籍区县:" label-width="100px">
              <div class="div">{{ form.residenceCounty }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属公司:" label-width="100px">
              <div class="div">{{ form.company }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="高考省份:" label-width="100px">
              <div class="div">{{ form.sysProvince }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="高考模式:" label-width="100px">
              <div v-if="form.pattern === 1" class="div">3 + 3</div>
              <div v-if="form.pattern === 2" class="div">3 + 1 + 2</div>
              <div v-if="form.pattern === 3" class="div">文理分科</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="选考科目:" label-width="100px" v-if="form.pattern === 1">
              <!-- <el-col>
                    <el-checkbox-group v-model="form.discipline" :max="3">
                      <el-checkbox label="化学" disabled>化学</el-checkbox>
                      <el-checkbox label="政治" disabled>政治</el-checkbox>
                      <el-checkbox label="物理" disabled>物理</el-checkbox>
                      <el-checkbox label="历史" disabled>历史</el-checkbox>
                      <el-checkbox label="生物" disabled>生物</el-checkbox>
                      <el-checkbox label="地理" disabled>地理</el-checkbox>
                    </el-checkbox-group>
                  </el-col>-->
              <div class="div">{{ form.discipline + "" }}</div>
            </el-form-item>
            <el-form-item label="选考科目:" label-width="100px" v-if="form.pattern === 2">
              <div class="div">{{ form.discipline }}</div>
            </el-form-item>
            <el-form-item label="选考科目:" label-width="100px" v-if="form.pattern === 3">
              <div v-if="form.disciplineType === 2" class="div">文科</div>
              <div v-if="form.disciplineType === 1" class="div">理科</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="少数民族:" label-width="100px">
              <div v-if="form.isMinority === 1" class="div">是</div>
              <div v-if="form.isMinority === 0" class="div">否</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="色觉异常:" label-width="100px">
              <div v-if="form.colorWeakness === 0" class="div">无</div>
              <div v-if="form.colorWeakness === 1" class="div">Ⅰ度（色弱）</div>
              <div v-if="form.colorWeakness === 2" class="div">Ⅱ度（色盲）</div>
              <div v-if="form.colorWeakness === 2" class="div">
                Ⅲ度（不能识别颜色）
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="国家专项:" label-width="100px">
              <div v-if="form.isNationalSpecial === 1" class="div">是</div>
              <div v-if="form.isNationalSpecial === 0" class="div">否</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="地方专项:" label-width="100px">
              <div v-if="form.isLocalSpecial === 1" class="div">是</div>
              <div v-if="form.isLocalSpecial === 0" class="div">否</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="高校专项:" label-width="100px">
              <div v-if="form.isUniversitySpecial === 1" class="div">是</div>
              <div v-if="form.isUniversitySpecial === 0" class="div">否</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="签约人:" label-width="100px">
              <div class="div">{{ form.signName }}</div>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
          <el-form-item label="身份证号码:" label-width="100px">
            <div class="div">{{form.identityNumber}}</div>
          </el-form-item>
        </el-col> -->
          <el-col :span="8">
            <el-form-item label="身份证号码:" label-width="100px">
              <div class="div">{{ form.signIdCard }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="签约人电话:" label-width="100px">
              <div class="div">{{ form.signPhone }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人1:" label-width="100px">
              <div class="div">{{ form.fatherName }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="关系:" label-width="100px">
              <div class="div">{{ filterContactShip(form.fatherShip) }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人1电话:" label-width="100px">
              <div class="div">{{ form.fatherPhone }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人2:" label-width="100px">
              <div class="div">{{ form.motherName }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="关系:" label-width="100px">
              <div class="div">{{ filterContactShip(form.matherShip) }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人2电话:" label-width="100px">
              <div class="div">{{ form.motherPhone }}</div>
            </el-form-item>
          </el-col>
          <el-form-item label="备注:" label-width="100px">
            <div class="div" style="width: 720px; height: 150px;padding: 8px;" v-html="form.remark">
            </div>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="成绩信息" name="second">
        <div class="title">
          <span class="titleline"></span>
          <span class="titletext">高考成绩</span>
        </div>
        <el-form :inline="true" :model="formscores">
          <el-form-item label="语文:">
            <el-input style="width: 100px; margin-right: 20px" size="small" @blur="scoreChange"
                      v-model="formscores.chineseScore" class="el-input"></el-input>
          </el-form-item>
          <el-form-item label="数学:">
            <el-input style="width: 100px; margin-right: 20px" size="small" @blur="scoreChange"
                      v-model="formscores.mathematicsScore" class="el-input"></el-input>
          </el-form-item>
          <el-form-item label="外语:">
            <el-input style="width: 100px; margin-right: 20px" size="small" @blur="scoreChange"
                      v-model="formscores.englishScore" class="el-input"></el-input>
          </el-form-item>
          <el-form-item label="物理:" v-if="form.discipline && form.discipline.includes('物理')">
            <el-input style="width: 100px; margin-right: 20px" size="small" @blur="scoreChange"
                      v-model="formscores.physicsScore" class="el-input"></el-input>
          </el-form-item>
          <el-form-item label="历史:" v-if="form.discipline && form.discipline.includes('历史')">
            <el-input style="width: 100px; margin-right: 20px" size="small" @blur="scoreChange"
                      v-model="formscores.historyScore" class="el-input"></el-input>
          </el-form-item>
          <el-form-item label="化学:" v-if="form.discipline && form.discipline.includes('化学')">
            <el-input style="width: 100px; margin-right: 20px" size="small" @blur="scoreChange"
                      v-model="formscores.chemistryScore" class="el-input"></el-input>
          </el-form-item>
          <el-form-item label="生物:" v-if="form.discipline && form.discipline.includes('生物')">
            <el-input style="width: 100px; margin-right: 20px" size="small" @blur="scoreChange"
                      v-model="formscores.biologyScore" class="el-input"></el-input>
          </el-form-item>
          <el-form-item label="政治:" v-if="form.discipline && form.discipline.includes('政治')">
            <el-input style="width: 100px; margin-right: 20px" size="small" @blur="scoreChange"
                      v-model="formscores.politicsScore" class="el-input"></el-input>
          </el-form-item>
          <el-form-item label="地理:" v-if="form.discipline && form.discipline.includes('地理')">
            <el-input style="width: 100px; margin-right: 20px" size="small" @blur="scoreChange"
                      v-model="formscores.geographyScore" class="el-input"></el-input>
          </el-form-item>
          <el-form-item label="综合:" v-if="form.pattern === 3">
            <el-input style="width: 100px; margin-right: 20px" size="small" @blur="scoreChange"
                      v-model="formscores.comprehensiveScore" class="el-input"></el-input>
          </el-form-item>
          <el-form-item label="加分:">
            <el-input style="width: 100px; margin-right: 20px" size="small" @blur="scoreChange"
                      v-model="formscores.extraScore" class="el-input"></el-input>
          </el-form-item>
          <el-form-item label="总分:">
            <el-input style="width: 100px; margin-right: 20px" size="small" v-model="formscores.totalScore"
                      class="el-input"></el-input>
          </el-form-item>
          <el-form-item label="位次:">
            <el-input style="width: 100px; margin-right: 20px" size="small" v-model="formscores.accumulate"
                      class="el-input"></el-input>
          </el-form-item>
        </el-form>
        <div class="footer">
          <el-button size="small" type="primary" @click="saveStudentScore" v-permission="'400119'">保存</el-button>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {getStudentDetail, obtainRankingByScore, saveStudentScore,} from "@/api/serviceManagement.js";
import rules from "@/util/rules.js";

export default {
  props: {
    userform: {
      Type: Object,
      default: () => {
      },
    },
    sixactiveName: {
      Type: String,
      default: "first",
    },
  },
  data() {
    return {
      rulesUtils: rules,
      form: {},
      formscores: {
        chineseScore: "",
        mathematicsScore: "",
        englishScore: "",
        physicsScore: "",
        historyScore: "",
        chemistryScore: "",
        biologyScore: "",
        politicsScore: "",
        geographyScore: "",
        comprehensiveScore: "",
        extraScore: "",
        totalScore: 0,
        accumulate: "",
      },
      user: {},
    };
  },
  watch: {
    userform: {
      immediate: true, //绑定值就开始执行监听，而不是等值改变。
      handler(newValue, oldValue) {
        this.user = newValue;
        if (this.user.studentId) {
          this.getStudentDetail();
        }
      },
      deep: true,
    },
  },
  mounted() {
  },
  methods: {
    handleClick(tab, event) {
    },
    saveStudentScore() {

      if (!this.formscores.chineseScore) {
        this.$message.warning("请输入语文成绩")
        return;
      }
      if (!this.formscores.mathematicsScore) {
        this.$message.warning("请输入数学成绩")
        return;
      }
      if (!this.formscores.englishScore) {
        this.$message.warning("请输入外语成绩")
        return;
      }
      if (this.form.discipline.includes('物理') && !this.formscores.physicsScore) {
        this.$message.warning("请输入物理成绩")
        return;
      }
      if (this.form.discipline.includes('历史') && !this.formscores.historyScore) {
        this.$message.warning("请输入历史成绩")
        return;
      }
      if (this.form.discipline.includes('化学') && !this.formscores.chemistryScore) {
        this.$message.warning("请输入化学成绩")
        return;
      }
      if (this.form.discipline.includes('生物') && !this.formscores.biologyScore) {
        this.$message.warning("请输入生物成绩")
        return;
      }
      if (this.form.discipline.includes('政治') && !this.formscores.politicsScore) {
        this.$message.warning("请输入政治成绩")
        return;
      }
      if (this.form.discipline.includes('地理') && !this.formscores.geographyScore) {
        this.$message.warning("请输入地理成绩")
        return;
      }
      if (this.form.pattern === 3 && !this.formscores.comprehensiveScore) {
        this.$message.warning("请输入综合成绩")
        return;
      }

      if (!this.formscores.accumulate && this.formscores.totalScore) {
        let currentYear = new Date().getFullYear();
        let graduateYear = this.form.graduateYear;
        if (graduateYear >= currentYear) {
          this.obtainRankingByScore(currentYear, true);
        } else {
          this.obtainRankingByScore(graduateYear, true);
        }
      } else {
        this.formscores.studentId = this.user.studentId;
        saveStudentScore(this.formscores).then((res) => {
          if (res.code === 1) {
            this.$message.success("保存成功");
            this.$emit("scoreChange", this.user.studentId, true);
          }
        });
      }
    },
    getStudentDetail() {
      getStudentDetail({studentId: this.user.studentId}).then((res) => {
        this.form = res.data || {};
        this.form.sysProvince = this.form.examProvince;
        this.form.school = this.form.schoolName;
        this.form.company = res.data.companyName;
        this.form.discipline = res.data.discipline;
        if (this.form.scores) {
          this.formscores = this.form.scores
        }
      });
    },
    filterContactShip(ship) {
      switch (ship) {
        case "1":
          return "父子";
        case "2":
          return "父女";
        case "3":
          return "母子";
        case "4":
          return "母女";
        case "5":
          return "其他";
      }
    },
    scoreChange() {
      console.log("高考成绩变化")
      let totalScore = 0;
      try {
        totalScore =
            (this.formscores.chineseScore ? parseInt(this.formscores.chineseScore) : 0) +
            (this.formscores.mathematicsScore ? parseInt(this.formscores.mathematicsScore) : 0) +
            (this.formscores.englishScore ? parseInt(this.formscores.englishScore) : 0);

        if (this.form.discipline.includes('物理')) {
          totalScore += (this.formscores.physicsScore ? parseInt(this.formscores.physicsScore) : 0)
        }

        if (this.form.discipline.includes('历史')) {
          totalScore += (this.formscores.historyScore ? parseInt(this.formscores.historyScore) : 0)
        }
        if (this.form.discipline.includes('化学')) {
          totalScore += (this.formscores.chemistryScore ? parseInt(this.formscores.chemistryScore) : 0)
        }
        if (this.form.discipline.includes('生物')) {
          totalScore += (this.formscores.biologyScore ? parseInt(this.formscores.biologyScore) : 0)
        }
        if (this.form.discipline.includes('政治')) {
          totalScore += (this.formscores.politicsScore ? parseInt(this.formscores.politicsScore) : 0)
        }
        if (this.form.discipline.includes('地理')) {
          totalScore += (this.formscores.geographyScore ? parseInt(this.formscores.geographyScore) : 0)
        }
        if (this.form.pattern === 3){
          totalScore += (this.formscores.geographyScore ? parseInt(this.formscores.comprehensiveScore) : 0)
        }

        totalScore += (this.formscores.extraScore ? parseInt(this.formscores.extraScore) : 0)

      } catch (e) {
        console.log(e, "总分异常");
      }
      this.formscores.totalScore = totalScore;
      console.log(totalScore, "总分")
    },

    totalScoreChange() {
      let currentYear = new Date().getFullYear();
      let graduateYear = this.form.graduateYear;
      if (graduateYear >= currentYear) {
        this.obtainRankingByScore(currentYear, false);
      } else {
        this.obtainRankingByScore(graduateYear, false);
      }

    },

    /**
     * 根据分数查位次
     */
    obtainRankingByScore(year, needSave) {
      let params = {};
      params.province = {
        id: this.form.province,
        name: this.form.examProvince,
      };
      params.year = year;
      params.scoreMin = this.formscores.totalScore;
      params.disciplineType = this.form.disciplineType;

      obtainRankingByScore(params).then((res) => {
        if (res.code === 1) {
          if (res.data || res.data === 0 || res.data === '0') {
            this.formscores.accumulate = res.data;

            this.formscores.studentId = this.user.studentId;
            if (needSave) {
              saveStudentScore(this.formscores).then((res) => {
                if (res.code === 1) {
                  this.$message.success("保存成功");
                  this.$emit("scoreChange", this.user.studentId, true);
                }
              });
            }
          } else {
            if (params.year === new Date().getFullYear()) {
              this.obtainRankingByScore(new Date().getFullYear() - 1, needSave);
            } else {
              this.$message.warning("未匹配到位次，成绩保存失败");
            }
          }
        } else {
          this.formscores.accumulate = "";
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  margin-top: 10px;

  .titleline {
    display: inline-block;
    width: 4px;
    height: 20px;
    margin-right: 10px;
    background-color: #1ab394;
    border-radius: 2px;
  }

  .titletext {
    display: inline-block;
    font-weight: 700;
    color: #000;
    vertical-align: top;
  }
}

.div {
  border: 1px solid #e5e5e5;
  width: 180px;
  margin-top: 5px;
  height: 30px;
  line-height: 30px;
  padding-left: 20px;
  border-radius: 5px;
  color: #606266;
}

/deep/ .group {
  display: inline-block;
}

.kong {
  color: rgba(0, 0, 0, 0);
}

.footer {
  margin-top: 100px;
  display: flex;
  justify-content: center;
}
</style>
